export const environment = {
  production: false,
  gtmPruebas: false,
  domain: 'midatacredito.com',
  oktaConfig: {
    clientId: 'rGbQbHZM0CRPg4SODmxO20NoEkvN9Vn+w9M3j1Q69Bw=',
  },
  country: 'CO',
  buscacredito: false,
  enlaceBuscaCredito: 'https://buscacredito.midatacredito.com/',
  APIEndPoints: {
    urlEndPoints: 'https://www.midatacredito.com/verifica/',
  },
  verifica: {
    consultaCiudadano: 'vrfycstmr/verify/customerValidation',
    responderSolicitud: 'vrfycstmr/verify/emailCodeVerification',
    consultarHistorico: 'vrfycstmr/verify/queryHistory',
    consultarPrecio: 'vrfycstmr/verify/checkPlanPrice',
    redimirPromo: 'vrfycstmr/verify/promocodeValidation',
    validationSession: 'authn-ws/authn/validateSession',
    signOff: 'authn-ws/authn/signOff',
    urlLogin: 'https://usuario.midatacredito.com/login?product=vrf',
    urlRegister: 'https://usuario.midatacredito.com/registro?product=vrf',
  },
  slotsBanners: {
    home_1: '/22857899675/Ad_Unit_Verifica01',
    home_2: '/22857899675/Ad_Unit_Verifica02',
    prelogin: '/22857899675/Ad_Unit_VerificaPrelogin'
  }
};